/**
 * Copyright © Veeam Software Group GmbH.
 */

import { baseConfig } from './base.config';
import { PortalUserRoles } from '../../../entries/portal-user/enums';
import { ConfigSectionIds, ConfigStates } from '../enums';

import type { BaseUserConfig } from '../interfaces';

export const serviceProviderOperatorConfig: BaseUserConfig = {
    baseConfig: baseConfig,
    roleInt: PortalUserRoles.ServiceProviderOperator,
    roleName: PortalUserRoles[PortalUserRoles.ServiceProviderOperator] as keyof typeof PortalUserRoles,
    routes: [],
    sections: [
        {
            id: ConfigSectionIds.BackupJobsVirtualMachinesVirtualInfrastructure,
            actions: {
                separatorBeforeDownloadRemoteConsole: ConfigStates.Hidden,
                downloadRemoteConsole: ConfigStates.Hidden,
            },
        },
        {
            id: ConfigSectionIds.ReportsConfigurationsWizard,
            columns: {
                managedBy: ConfigStates.Hidden,
            },
        },
    ],
};
